// extracted by mini-css-extract-plugin
export default {"divHeader":"SelectInstance_divHeader__YtRN5"};